import React from "react";
import { Modal } from "@/app/(components)/Basic/Modal";
import { Button } from "@/app/(components)/Basic/Button";
import LoaderIcon from "@/assets/icons/loader.svg";

export interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  isLoading: boolean;
  title?: string;
  text?: string;
}

const ConfirmModal = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  title,
  text,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="flex flex-col items-center"
      hasCloseButton
      title={title}
    >
      {text}
      <span className="flex gap-x-10 mt-10">
        <Button
          onClick={onSubmit}
          disabled={isLoading}
          startIcon={isLoading ? <LoaderIcon className="w-6 h-6" /> : null}
          type="button"
        >
          Yes
        </Button>
        <Button onClick={onClose} disabled={isLoading} type="button">
          No
        </Button>
      </span>
    </Modal>
  );
};

export default ConfirmModal;
